import React, { useState } from 'react'
import Layout from '../../../components/layouts/Layout'
import { useTranslation } from 'react-i18next'
import CategoriesSection from '../../../components/store/reusable/category/CategoriesSection'
import { useParams, useSearchParams } from 'react-router-dom';
import { OrderStatus } from '../../../types/enum/orderStatus';
import OrdersTable from '../../../components/store/orders/OrdersListTable';
import { useStoreOrders } from '../../../hooks/store/orders';
import LoadingErrorState from '../../../components/ui/LoadingErrorState';
import Pagination from '../../../components/ui/Pagination';
import EmptyData from '../../../components/ui/EmptyData';

function StoreOrdersOverView() {
    const { storeId} = useParams<{ storeId: string}>();
    const numericStoreId = storeId ? parseInt(storeId) : undefined;
  
    const {t} = useTranslation() ;

      const categories :{id:string, name:string}[] = [
          { id: OrderStatus.completed, name: t(OrderStatus.completed) },
          { id: OrderStatus.cancelled, name: t(OrderStatus.cancelled) },
        ];

        if(numericStoreId){
          categories.push({id:"Tracking",name:t("inProgress")});
        }

      const [searchParams,setSearchParams] = useSearchParams();
      const category = searchParams.get("category");
      const pageQuery = Number(searchParams.get('page')) || 1;
      const {data:orders ,isError, isLoading} = useStoreOrders({status:category||"completedOrCanceled",storeId:numericStoreId,page:pageQuery});

      const handlePagination = (page: number) => {
        const newParams = new URLSearchParams(searchParams);
        newParams.set('page', page.toString());
        setSearchParams(newParams);
    };

  return (
    <Layout title={t('layout_titles.orders')} headline={t('orders_headline',{num:orders?.orders.length})}>
        <CategoriesSection
        selectedCategory={category?category:""}
        categories={categories}
        buttonAddLinkPath={""}
        buttonLinkPath={""}
        buttonLabel=''
        showAdd={false}
        notShowAddButton={true}
      />
      <LoadingErrorState
      isError={isError}
      isLoading={isLoading}
      />
      {
        orders && (
          orders.orders.length === 0 ?<EmptyData/> : 
          <>
          <OrdersTable orders={orders.orders}/>
          <Pagination
            currentPage={pageQuery}
            totalPages={orders?.totalPages||0}
            handlePagination={handlePagination}
          />
          </>
        )
      }
    </Layout>
  )
}

export default StoreOrdersOverView